"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlacePageIconContainer = void 0;
const tslib_1 = require("tslib");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const react_1 = tslib_1.__importDefault(require("react"));
function PlacePageIconContainer({ title, children }) {
    return (react_1.default.createElement("div", { className: data_catalog_shared_1.placePageIconContainerClass, title: title }, children));
}
exports.PlacePageIconContainer = PlacePageIconContainer;
//# sourceMappingURL=PlacePageIconContainer.js.map